import {Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {PasswordVerificationDialogComponent} from '../components/shared/password-protection/password-verification-dialog.component';

@Injectable({
  providedIn: 'root'
})

export class PasswordVerificationService {

  constructor(private dialog: MatDialog) {
  }

  checkPassword(): Promise<void> {
    return this.dialog.open(PasswordVerificationDialogComponent).componentInstance.promise();
  }
}
